import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** Merge class names with clsx, then de-duplicate conflicting Tailwind utilities. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
